import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Button, Typography, Box } from '@mui/material';

import BaseModal from '@components/molecules/modals/BaseModal';
import useReportService from '@services/report';

const MonthlyReportNotification = () => {
    const [open, setOpen] = useState(false);
    const [reportData, setReportData] = useState(null);
    const [currentRole, setCurrentRole] = useState(Number(sessionStorage.getItem('currentUserRole') ?? 0));
    const reportService = useReportService();
    const user = useSelector((state) => state.auth.user);
    const navigate = useNavigate();

    // Monitora mudanças no sessionStorage (troca de role)
    useEffect(() => {
        const checkRoleChange = () => {
            const newRole = Number(sessionStorage.getItem('currentUserRole') ?? 0);
            if (newRole !== currentRole) {
                setCurrentRole(newRole);
            }
        };

        // Verifica a cada 500ms se a role mudou
        const interval = setInterval(checkRoleChange, 500);

        return () => clearInterval(interval);
    }, [currentRole]);

    useEffect(() => {
        // Aguarda usuário estar autenticado, ter empresa, ter role de coordenador E estar logado como coordenador
        if (user?.id && user?.enterprise?.id && user.roles.includes(4) && currentRole === 4) {
            checkNewReport();
        }
    }, [user, currentRole]);

    const checkNewReport = async () => {
        try {
            const response = await reportService.checkNewMonthlyReport(user?.enterprise?.id);

            if (response.has_new_report) {
                setReportData(response);
                setTimeout(() => {
                    setOpen(true);
                }, 3000);
            }
        } catch (error) {
            console.error('Erro ao verificar relatórios:', error);
        }
    };

    const handleGoToReports = async () => {
        await markAsViewed();
        setOpen(false);
        navigate(`/coordenador/empresa/geral/${user?.enterprise?.id}/reports`);
    };

    const handleClose = async () => {
        await markAsViewed();
        setOpen(false);
    };

    const markAsViewed = async () => {
        if (reportData?.enterprise_id && reportData?.report_date) {
            try {
                await reportService.markMonthlyReportViewed(reportData.enterprise_id, reportData.report_date);
            } catch (error) {
                console.error('Erro ao marcar como visto:', error);
            }
        }
    };

    if (!reportData) return null;

    return (
        <BaseModal
            title="Relatórios mensais prontos para análise"
            open={open}
            handleClose={handleClose}
            maxWidth="sm"
            centerActions={true}
            withActions={
                <>
                    <Button onClick={handleClose} variant="outlined" color="inherit">
                        Agora não
                    </Button>
                    <Button onClick={handleGoToReports} variant="contained" color="primary">
                        Ver relatórios
                    </Button>
                </>
            }
        >
            <Box sx={{ textAlign: 'center', py: 3 }}>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 500 }}>
                    Já está disponível o arquivo com todos os relatórios dos consultores deste mês.
                </Typography>

                <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
                    Deseja ir para página de relatórios?
                </Typography>
            </Box>
        </BaseModal>
    );
};

export default MonthlyReportNotification;
